import moment from "moment";

export const DEFAULT_MINIMUM_NON_WRAP_UPFRONT_FEE = 1;

export const normalizeMinimumUpfrontFee = (value) => {
  const num = Number(value);
  if (Number.isNaN(num) || num < 0) return DEFAULT_MINIMUM_NON_WRAP_UPFRONT_FEE;
  return num;
};

const normalizeRule = (rule = {}) => {
  if (!rule) return null;
  const effectiveFrom = rule.effectiveFrom
    ? moment(rule.effectiveFrom).startOf("day").toDate()
    : null;
  return {
    effectiveFrom,
    minimumUpfrontFee: normalizeMinimumUpfrontFee(rule.minimumUpfrontFee),
  };
};

export const normalizeNonWrapUpfrontFeeRules = (investmentTransaction = {}) => {
  const rules = investmentTransaction?.nonWrapUpfrontFeeRules;
  if (Array.isArray(rules) && rules.length) {
    return rules.map(normalizeRule).filter(Boolean);
  }

  if (investmentTransaction?.upfrontFee != null) {
    return [
      {
        effectiveFrom: null,
        minimumUpfrontFee: normalizeMinimumUpfrontFee(
          investmentTransaction.upfrontFee
        ),
      },
    ];
  }

  return [
    {
      effectiveFrom: null,
      minimumUpfrontFee: DEFAULT_MINIMUM_NON_WRAP_UPFRONT_FEE,
    },
  ];
};

export const resolveMinimumNonWrapUpfrontFee = (rules = [], signDate) => {
  const normalized = Array.isArray(rules)
    ? rules.map(normalizeRule).filter(Boolean)
    : normalizeNonWrapUpfrontFeeRules({ nonWrapUpfrontFeeRules: rules });

  const asOf = moment(signDate || new Date()).startOf("day");
  const eligible = normalized.filter((rule) => {
    if (!rule.effectiveFrom) return true;
    return moment(rule.effectiveFrom).startOf("day").isSameOrBefore(asOf, "day");
  });

  if (!eligible.length) return DEFAULT_MINIMUM_NON_WRAP_UPFRONT_FEE;

  eligible.sort((a, b) => {
    const aTime = a.effectiveFrom ? moment(a.effectiveFrom).valueOf() : 0;
    const bTime = b.effectiveFrom ? moment(b.effectiveFrom).valueOf() : 0;
    return bTime - aTime;
  });

  return eligible[0].minimumUpfrontFee;
};

export const serializeNonWrapUpfrontFeeRules = (rules = []) =>
  rules
    .map((rule) => ({
      effectiveFrom: rule.effectiveFrom
        ? moment(rule.effectiveFrom).startOf("day").toISOString()
        : null,
      minimumUpfrontFee: normalizeMinimumUpfrontFee(rule.minimumUpfrontFee),
    }))
    .sort(
      (a, b) =>
        moment(a.effectiveFrom || 0).valueOf() -
        moment(b.effectiveFrom || 0).valueOf()
    );

export const formatEffectiveFromLabel = (value) => {
  if (!value) return "From beginning";
  return moment(value).format("DD/MM/YYYY");
};
